module.exports = __webpack_public_path__ + "static/media/progressiveWasteSolutions.4e2985cd.png";